import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/accounting/closingDayReport/filter'; // Importing Filter component
import Table from 'views/accounting/closingDayReport/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the closing day report view.
 * @extends JetView
 */
export default class closingDayReportView extends JetView {
    /**
     * Configures the layout of the closing day report view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            // Right section configuration
            type: 'wide',
            rows: [],
        };
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: 10000,
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' },
                        { id: '2', value: 'PDF' },
                    ],
                    on: {
                        // Event handlers for the richselect
                        onChange: function (value) {
                            if (value == 1) {
                                // Export to Excel
                                var table = $$('ClosingDay'); // Reference to the ClosingDay table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel function
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Reporte de cierre de día'),
                                });
                            } else {
                                if (value == 2) {
                                    // Export to PDF
                                    webix.toPDF($$('ClosingDay'), {
                                        // Export to PDF function
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reporte de cierre de día'),
                                        autowidth: true,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            // Left section configuration
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        { view: 'label', label: _('Reporte de cierre de día') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Close icon
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                Filter, // Filter component
                { id: 'res2', view: 'resizer' }, // Resizer for layout adjustment
                Table, // Table component
                toolbar, // Toolbar component
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Main configuration object for the view
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left section included in the layout
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                // Check screen width for responsiveness
                $$('res2').hide(); // Hide resizer on small screens
            }
        });
    }
}

// FILE DOCUMENTED
